export default function () {
    const mainHeader = document.querySelector('#masthead');
    const mainHeaderNavbar = mainHeader.querySelector('.navbar');
    /**
     *  Scroll handling
     */
    let lastScrollTop = 0;
    const isScrollingDown = () => {
        let goingDown = false;
        let st = window.scrollY || document.documentElement.scrollTop;
        goingDown = st > lastScrollTop;
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        return goingDown;
    };

    const handleScroll = () => {
        if (isScrollingDown()) {
            document.body.classList.remove("scroll-up");
            document.body.classList.add("scroll-down");
        } else {
            document.body.classList.add("scroll-up");
            document.body.classList.remove("scroll-down");
            mainHeaderNavbar.classList.replace('navbar-dark', 'navbar-light')
        }
        if (window.scrollY < 100) {
            document.body.classList.remove("scroll-up");
            mainHeaderNavbar.classList.remove('navbar-dark', 'navbar-light');
            if (mainHeaderNavbar.dataset.theme) {
                mainHeaderNavbar.classList.add(mainHeaderNavbar.dataset.theme);
            }
        }
    };
    window.addEventListener("scroll", handleScroll);
}
